module.exports = __webpack_public_path__ + "img/360氪PC图片.ed9362cd.jpg";